// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1InM8","title":"AfterBackImages_title__--0l3","images":"AfterBackImages_images__2fEZW"};